<ng-container [formGroup]="bidDetailForm">
  <div class="card-body">
    <div class="d-flex">
      <h2>Bid Details </h2>
      <div class="pl-3" [ngStyle]="{ display: isEdit ? 'none' : 'block' }"><app-module-office-selection [isEdit]="isEdit" [model]="model"  (callback)="changeOfficeSelection($event)"></app-module-office-selection></div>

    </div>
    <div class="form-row">
      <div class="form-group col-12">
        <label for="name" class="custom_label">Bid Name *</label>
        <input matInput type="text" id="name" formControlName="name" class="form-control" placeholder="Bid Name" name="name">
        <app-validation-error [formGroup]="bidDetailForm" [controlName]="'name'"></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="building_specifications" class="custom_label">Building Specifications</label>
        <input matInput type="text" id="building_specifications" formControlName="building_specifications" class="form-control" placeholder="Building Specifications" name="building_specifications">
      </div>
    </div>

    @if (!isEdit) {
      <app-customer-contact-selection-dropdown
        [createContactPermission]="'CONTACT-BIDS-RELATED-CREATE'"
        [createCustomerPermission]="'BIDDERS-BIDS-RELATED-CREATE'"
        [DefaultContactId]="DefaultContactId"
        [DefaultCustomerId]="DefaultCustomerId"
        (onCustomerChange)="onChangeCustomer($event)"
        formControlName="customer"
        [form]="form"
        [model]="model">
      </app-customer-contact-selection-dropdown>
    }

    <div class="form-group bid-due-date-group">
      <label class="custom_label">Bid Due Date *</label>
      <mat-form-field appearance="fill" class="input_datepicker bid_input_datepicker" style="padding-bottom: 0px;">
        <mat-label>Bid Due Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="due_date_at">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <app-validation-error [formGroup]="bidDetailForm" [controlName]="'due_date_at'"></app-validation-error>

    </div>
    <div class="form-group bid-due-time-group">
      <label class="custom_label">Bid Due Time *</label>
      <mat-form-field appearance="fill" class="input_datepicker bid_due_time_field" style="padding-bottom: 0px;">
        <mat-label>Bid Due Time</mat-label>
        <input matInput [matTimepicker]="timePicker"
          placeholder="Select due time" formControlName="startTime">
        <mat-timepicker-toggle matIconSuffix [for]="timePicker" class="time-picker-icon"></mat-timepicker-toggle>
        <mat-timepicker #timePicker interval="15 minutes" panelClass="bid-time-panel"></mat-timepicker>
      </mat-form-field>
      <app-validation-error [formGroup]="bidDetailForm" [controlName]="'startTime'"></app-validation-error>
    </div>
  </div>
</ng-container>
